import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { MdEmail, MdPhone, MdAndroid } from "react-icons/md";

import styles from "./Footer.module.scss";
import {
  MAIN_ROUTE,
  CLUSTERS_ROUTE,
  CATEGORIES_ROUTE,
  ITEMS_ROUTE,
  PROMOS_ROUTE,
  PRIVACY_POLICY_ROUTE,
  USER_AGREEMENT_ROUTE,
  PERSONAL_DATA_AGREEMENT_ROUTE,
} from "../../utils/constants";
import { StoreButton } from "../storeButton/StoreButton";

import appStoreLight from "../../../assets/images/app-stores/app_store_light.svg";
import ruStoreLight from "../../../assets/images/app-stores/ru_store_dark.svg";

const COUNTRY = process.env.REACT_APP_COUNTRY || "ru";
const SHOW_US = process.env.REACT_APP_SHOW_US !== "false";
const APPSTORE_URL = process.env.REACT_APP_APPSTORE_URL;
const RUSTORE_URL = process.env.REACT_APP_RUSTORE_URL;
const APK_URL = process.env.REACT_APP_APK_URL;

export const Footer: React.FC = () => {
  const year = new Date().getFullYear();
  const [searchParams] = useSearchParams();
  const isPrerender = searchParams.get("__prerender") === "1";

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.grid}>
          <div className={styles.column}>
            <Link to={MAIN_ROUTE} className={styles.logoLink}>
              <img
                src="/icons/logo192.png"
                alt="ЛОГМОЛЛ"
                className={styles.logoImage}
              />
            </Link>
            <p className={styles.description}>
              Маркетплейс товаров и брендов в экосистеме ЛОГАЙДИ
            </p>
            <div className={styles.contacts}>
              <a
                href={`mailto:support@logmall.${COUNTRY}`}
                className={styles.link}
              >
                <MdEmail size={14} />
                <span>support@logmall.{COUNTRY}</span>
              </a>
              <a href="tel:+79940822881" className={styles.link}>
                <MdPhone size={14} />
                <span>+7 (994) 082-28-81</span>
              </a>
            </div>
          </div>

          <div className={styles.column}>
            <h3 className={styles.columnTitle}>Разделы</h3>
            <ul className={styles.links}>
              <li>
                <Link to={CLUSTERS_ROUTE} className={styles.link}>
                  Компании
                </Link>
              </li>
              <li>
                <Link to={CATEGORIES_ROUTE} className={styles.link}>
                  Категории
                </Link>
              </li>
              <li>
                <Link to={ITEMS_ROUTE} className={styles.link}>
                  Товары
                </Link>
              </li>
              <li>
                <Link to={PROMOS_ROUTE} className={styles.link}>
                  Акции
                </Link>
              </li>

              {/* 👇 только для пререндера */}
              {isPrerender && (
                <li>
                  <Link to={MAIN_ROUTE} className={styles.link}>
                    Все города
                  </Link>
                </li>
              )}
            </ul>

            <h3 className={styles.subTitle}>Для бизнеса</h3>
            <ul className={styles.links}>
              <li>
                <a
                  href="https://logid.ru"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.link}
                >
                  Разместить товары
                </a>
              </li>
              <li>
                <a
                  href="https://logid.ru"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.link}
                >
                  ЛОГАЙДИ
                </a>
              </li>
            </ul>
          </div>

          {(APPSTORE_URL || RUSTORE_URL || APK_URL) && (
            <div className={styles.column}>
              <h3 className={styles.columnTitle}>Приложение</h3>
              <div className={styles.stores}>
                {APPSTORE_URL && (
                  <StoreButton
                    href={APPSTORE_URL}
                    src={appStoreLight}
                    alt="Скачать в App Store"
                  />
                )}
                {RUSTORE_URL && (
                  <StoreButton
                    href={RUSTORE_URL}
                    src={ruStoreLight}
                    alt="Скачать в RuStore"
                  />
                )}
                {APK_URL && (
                  <StoreButton
                    href={APK_URL}
                    theme="light"
                    icon={MdAndroid}
                    text="Скачать для Android"
                  />
                )}
              </div>
            </div>
          )}

          <div className={styles.column}>
            <h3 className={styles.columnTitle}>Документы</h3>
            <ul className={styles.links}>
              <li>
                <Link to={PRIVACY_POLICY_ROUTE} className={styles.link}>
                  Политика конфиденциальности
                </Link>
              </li>
              <li>
                <Link to={USER_AGREEMENT_ROUTE} className={styles.link}>
                  Пользовательское соглашение
                </Link>
              </li>
              <li>
                <Link
                  to={PERSONAL_DATA_AGREEMENT_ROUTE}
                  className={styles.link}
                >
                  Согласие на обработку данных
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className={styles.bottom}>
          <div className={styles.copyright}>© ЛОГАЙДИ {year}</div>

          {SHOW_US && (
            <>
              <div className={styles.studioLink}>
                Сайт сделан в{" "}
                <a
                  href="https://seacoding.ru"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  СИ КОДИНГ | SEA CODING
                </a>
              </div>
              <div className={styles.studioLink}>
                Платформа{" "}
                <a
                  href="https://logid.ru"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  ЛОГАЙДИ | LOGID
                </a>
              </div>
            </>
          )}
        </div>
      </div>
    </footer>
  );
};
